import {
  enumCurrencyCode,
  enumFinancialAccountType,
  enumPaymentAllocationMethod,
  enumRoundingMethod,
  enumRoundingPrecision,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { FinancialAccountFormData } from '~/modules/finance/types';

const initialFormState: FinancialAccountFormData = {
  name: '',
  type: enumFinancialAccountType.Checking,
  currentBalance: 0,
  warningThreshold: 0,
  currency: enumCurrencyCode.USD,
  visibleInPayments: true,
  roundingMethod: enumRoundingMethod.Nearest,
  roundingPrecision: enumRoundingPrecision.Hundred,
  facilityId: null,
  nachaCompanyIdentification: '',
  nachaCompanyName: '',
  nachaDefaultSecCode: '',
  paymentAllocationMethod: enumPaymentAllocationMethod.WeightedDistribution,
};

// 🔘🔘🔘 PLAIN ATOMS
export const $financialAccountForm =
  atom<FinancialAccountFormData>(initialFormState);

// 🟠🟠🟠 ACTION -> UPDATE FORM DATA
export const $updateFinancialAccountForm = atom(
  null,
  (get, set, update: FinancialAccountFormData) => {
    set($financialAccountForm, update);
  },
);
